/*
  Category tabs.

  All panels are rendered by Liquid; this only switches which one is visible.
  Without JavaScript the panels stay as rendered and the page still works,
  so the control degrades to a stacked list rather than an empty section.

  Follows the ARIA tabs pattern: arrow keys move between tabs, Home and End
  jump to the ends, and only the selected tab is in the tab order.
*/
class EthirajTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });
  }

  panelFor(tab) {
    return document.getElementById(tab.getAttribute('aria-controls'));
  }

  select(tab, { focus = false } = {}) {
    this.tabs.forEach((other) => {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      other.setAttribute('tabindex', selected ? '0' : '-1');

      const panel = this.panelFor(other);
      if (panel) panel.hidden = !selected;
    });

    if (focus) tab.focus();
  }

  onKeydown(event) {
    const index = this.tabs.indexOf(event.currentTarget);
    let next = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = this.tabs[(index + 1) % this.tabs.length];
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        break;
      case 'Home':
        next = this.tabs[0];
        break;
      case 'End':
        next = this.tabs[this.tabs.length - 1];
        break;
      default:
        return;
    }

    event.preventDefault();
    this.select(next, { focus: true });
  }
}

if (!customElements.get('ethiraj-tabs')) {
  customElements.define('ethiraj-tabs', EthirajTabs);
}
